import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Orders from "./Pages/Orders/Orders";
import AllUsers from "./Pages/Users/AllUsers";
import Dashboard from "./Pages/Dashboard/Dashboard";
import PendingFund from "./Pages/FundRequest/Pending";  
import ApprovedFund from "./Pages/FundRequest/Approved";
import RejectedFund from "./Pages/FundRequest/Rejected";
import PendingWith from "./Pages/withdrawal/PendingWith";
import ApprovedWith from "./Pages/withdrawal/ApprovedWith";
import RejectedWith from "./Pages/withdrawal/RejectedWith";
import PendingReward from "./Pages/Rewards/PendingReward";
import ApprovedReward from "./Pages/Rewards/ApprovedReward";
import RejectedReward from "./Pages/Rewards/RejectedReward";
import EditProfile from "./Pages/EditProfile/EditProfile";
import PayoutManagement from "./Pages/PayoutReport/PayoutControls";
import IncomeReport from "./Pages/PayoutReport/IncomeReport.jsx";
import ROILevelIncome from "./Pages/PayoutReport/ROILevelIncome";
import RoyaltyIncome from "./Pages/PayoutReport/RoyaltyIncome";
import LevelIncome from "./Pages/PayoutReport/LevelIncome";
import RoyaltyBonus from "./Pages/PayoutReport/RoyaltyBonus";
import FundsManagement from "./Pages/FundRequest/FundControls";
import RewardsManagement from "./Pages/Rewards/RewardControls";
import WithdrawManagement from "./Pages/withdrawal/WithdrawControls";
import TokenWithdrawManagement from "./Pages/withdrawal_token/WithdrawaTokenController.jsx";
import AddFunds from "./Pages/AddFund/AddFund";
import FundsHistory from "./Pages/FundHistory/FundHistory";
import BankDetails from "./Pages/BankReports/BankDetails";
import UserBankDetails from "./Pages/BankReports/UserBankDetails";
import UPI from "./Pages/BankReports/Upi";
import BonanzaSetting from "./Pages/Bonanza/BonanzaSetting";
import RewardAchievers from "./Pages/RewardAchievers/RewardAchievers.jsx";
import AdvisorRanks from "./Pages/AdvisorRanks/AdvisorRanks.jsx";
import WithoutSponsor from "./Pages/WithoutSponsor/WithoutSponsor.jsx";
import OldUsers from "./Pages/OldUsers/OldUsers.jsx";
import IdSettlement from "./Pages/IdSettlement/IdSettlement.jsx";
import Royalty from "./Pages/Users/Royalty";
import SIPManagement from "./Pages/SIP/SIP_controls";
import ActiveSIP from "./Pages/SIP/ActiveSIP";
import CompletedSIP from "./Pages/SIP/CompletedSIP";
import ActiveSIPDetails from "./Pages/SIP/ActiveSIP_Details";
import KycControls from "./Pages/KYC Report/KycControls";
import AadharKycControls from "./Pages/KYC Report/AadharKycControls";
import KycReview from "./Pages/KycReview/KycReview.jsx";
import InstallmentManagement from "./Pages/Installments/InstallmentControls";
import UpcomingInstallment from "./Pages/Installments/UpcomingInstallment";
import UnpaidInstallment from "./Pages/Installments/UnpaidInstallment";
import BondPaper from "./Pages/Bond Paper/BondPaper";
import FundTransferHistory from "./Pages/FundTransferHistory/FundTransferHistory";
import AddFundHistory from "./Pages/AddFund/AddFundHistory";
import Web3 from "./Pages/BankReports/Web3.jsx";
import News from "./Pages/News/News.jsx";
import GeneralSettings from "./Pages/GeneralSettings/GeneralSettings.jsx";
import WithdrawnDetails from "./Pages/withdrawal/WithdrawDetails-old.jsx";
import RetrieveFunds from "./Pages/Retrieve Fund/RetrieveFunds.jsx";
import RetrieveFundHistory from "./Pages/RetrieveFundHistory/RetrieveFundHistory.jsx";
import ContractWithdrawal from "./Pages/Contract Withdrawal/ContractWithdrawal.jsx";
import TopUp   from "./Pages/TopUp/TopUp.jsx"
import GivePower from "./Pages/GivePower/GivePower.jsx";
import TeamIncome from "./Pages/TeamIncome/TeamIncome.jsx";
import UserRegister from "./Pages/UserRegister/UserRegister.jsx";
import Support from "./Pages/Support/Support";
import ChatTickets from "./Pages/Support/ChatTickets";
import ControlsReleaseIncome from "./Pages/ReleaseIncome/ControlsReleaseIncome";
import PendingIncome from "./Pages/ReleaseIncome/PendingIncome";
import ReleasedIncome from "./Pages/ReleaseIncome/ReleasedIncome";
import CommunityIncome from "./Pages/PayoutReport/CommunityIncome.jsx";
import SalaryIncome from "./Pages/PayoutReport/SalaryIncome.jsx";
import UtilityIncome from "./Pages/PayoutReport/UtilityIncome.jsx";
import AddCapping from "./Pages/Add Capping/AddCapping.jsx";
import BonusIncome from "./Pages/PayoutReport/BonusIncome.jsx";
import WorkingIncome from "./Pages/PayoutReport/WorkingIncome.jsx";
import FastTeamGrowIncome from "./Pages/PayoutReport/FastTeamGrowIncome.jsx";
import PriWithdrawControls from "./Pages/PrincipalWithdrawal/PrWithdrawControls.jsx";
import PriPendingWith from "./Pages/PrincipalWithdrawal/PriPendingWith.jsx";
import PriApprovedWith from "./Pages/PrincipalWithdrawal/PriApprovedWith.jsx";
import PriRejectedWith from "./Pages/PrincipalWithdrawal/PriRejectedWith.jsx";
import AllWorkingIncome from "./Pages/Users/AllWorkingIncome.jsx";
import AllFastTeamGrow from "./Pages/Users/AllFastTeamGrow.jsx";
import EmporiumRegularIncome from "./Pages/PayoutReport/EmporiumRegularIncome.jsx";
import EmporiumIncome from "./Pages/PayoutReport/EmporiumIncome.jsx";
import TwoFactorAuthSetup from "./Pages/2FA/2FA.jsx";
import EmailReqStatus from "./Pages/EmailReqStatus/EmailReqStatus.jsx";
import CoinSettings from "./Pages/CoinSetting/CoinSettings.jsx";
import PlanSettings from "./Pages/PlanSettings/PlanSettings.jsx";
import ActivationRequests from "./Pages/ActivationRequests/ActivationRequests.jsx";
import DepositAccounts from "./Pages/DepositAccounts/DepositAccounts.jsx";
import SubAdmins from "./Pages/SubAdmins/SubAdmins.jsx";
import AuditLog from "./Pages/SubAdmins/AuditLog.jsx";
import PayoutLedger from "./Pages/PayoutLedger/PayoutLedger.jsx";
import { useAdminAccess, canOpen, firstAllowedPage } from "./Config/adminAccess";
import PriHoldWith from "./Pages/PrincipalWithdrawal/PriHoldWith.jsx";
import PriApprovedHoldWith from "./Pages/PrincipalWithdrawal/PriApprovedHoldWith.jsx";
import PrWithdrawnDetails from "./Pages/PrincipalWithdrawal/PrWithdrawDetails.jsx";
import WithdrawnTokenDetails from "./Pages/withdrawal_token/WithdrawnTokenDetails.jsx";
import PrWithdrawnDetailsHold from "./Pages/PrincipalWithdrawal/PrWithdrawDetailsHold.jsx";
import RegisterUser from "./Pages/RegisterFakeUser/RegisterFakeUser.jsx";
import AdminBuyOrder from "./Pages/BuyFakeOrder/BuyFakeOrder.jsx";
import FakeWithdrwal from "./Pages/FakeWithdrwal/FakeWithdrwal.jsx";
import GenerateFakeEntries from "./Pages/AutomateEntries/AutomateEntries.jsx";
import TokenDistribution from "./Pages/Token Distribution/TokenDistribution.jsx";
import UpdateSlot from "./Pages/Update Slot/UpdateSlot.jsx";
import DummyUserWallet from "./Pages/RegisterFakeUser/DummyUserWallet.jsx";
import DummyTeamUpdate from "./Pages/RegisterFakeUser/DummyTeamUpdate.jsx";
import ConfirmPackageManually from "./Pages/ConfirmPackageManually/ConfirmPackageManually.jsx";
import MatchingBonus from "./Pages/PayoutReport/MatchingBonus.jsx";
import VvToken from "./Pages/PayoutReport/vvToken.jsx";
import WealthLockHistory from "./Pages/WealthLockHistory/WealthLockHistory.jsx";
import TeamDevelopmentBonus from "./Pages/Users/TeamDevelopmentBonus.jsx";
import VLVToken from "./Pages/PayoutReport/VLVToken.jsx";
import RentalIncome from "./Pages/PayoutReport/RentalIncome.jsx";
import SelfRentalIncome from "./Pages/PayoutReport/SelfRentalIncome.jsx";
import AchievementBonus from "./Pages/PayoutReport/AchievementBonus.jsx";
import Exclusive from "./Pages/PayoutReport/Exclusive.jsx";
import CompanyTurnover from "./Pages/PayoutReport/CompanyTurnover.jsx";

const NavPages = () => {
  const location = useLocation();
  const access = useAdminAccess();

  // Sub-admins open only the pages of their modules (the API refuses the rest anyway)
  if (access && access.role !== "admin") {
    const page = location.pathname.replace(/^\/dashboard\/?/, "").split("/")[0];
    if (!canOpen(access, page)) {
      const first = firstAllowedPage(access);
      if (first !== undefined && first !== page) {
        return <Navigate to={first ? `/dashboard/${first}` : "/dashboard"} replace />;
      }
      return (
        <section style={{ padding: 40 }}>
          <h4>No access</h4>
          <p>Your sub-admin account cannot open this page. Ask the admin for access.</p>
        </section>
      );
    }
  }

  return (
    <React.Fragment>
      <section>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/approved_fund" element={<ApprovedFund />} />
          <Route path="/pending_fund" element={<PendingFund />} />
          <Route path="/rejected_fund" element={<RejectedFund />} />
          <Route path="/fund_controls" element={<FundsManagement />} />
          <Route path="/fund_history" element={<FundsHistory />} />
          <Route path="/add_fund_history" element={<AddFundHistory />} />
          <Route path="/fund_transfer_history" element={<FundTransferHistory />} />
          <Route path="/rejected_reward" element={<RejectedReward />} />
          <Route path="/pending_reward" element={<PendingReward />} />
          <Route path="/approved_reward" element={<ApprovedReward />} />
          <Route path="/rewards" element={<RewardsManagement />} />
          <Route path="/rank" element={<RewardAchievers />} />
          <Route path="/advisor_ranks" element={<AdvisorRanks />} />
          <Route path="/without_sponsor" element={<WithoutSponsor />} />
          <Route path="/old_users" element={<OldUsers />} />
          <Route path="/team_development_bonus_user" element={<TeamDevelopmentBonus />} />
          <Route path="/chain" element={<Web3 />} />
          <Route path="/royalty" element={<Royalty />} />
          <Route path="/withdraw_controls" element={<WithdrawManagement />} />
          <Route path="/pending_withdrawal" element={<PendingWith />} />
          <Route path="/approved_withdrawal" element={<ApprovedWith />} />
          <Route path="/rejected_withdrawal" element={<RejectedWith />} />
          <Route path="/principal_withdrawal" element={<PriWithdrawControls />} />
          <Route path="/principal_pending_withdrawal" element={<PriPendingWith />} />
          <Route path="/principal_approved_withdrawal" element={<PriApprovedWith />} />
          <Route path="/principal_rejected_withdrawal" element={<PriRejectedWith />} />
          <Route path="/principal_hold_withdrawal" element={<PriHoldWith />} />
          <Route path="/principal_approved_hold_withdrawal" element={<PriApprovedHoldWith />} />
          <Route path="/principal_withdrawal_details" element={<PrWithdrawnDetails />} />
          <Route path="/principal_withdrawal_hold_details" element={<PrWithdrawnDetailsHold />} />
          <Route path="/token_withdraw_controls" element={<TokenWithdrawManagement />} />
          <Route path="/token_withdraw_controls" element={<TokenWithdrawManagement />} />
          <Route path="/withdraw-token-details" element={<WithdrawnTokenDetails />} />
          <Route path="/all_users" element={<AllUsers />} />
          <Route path="/top_up" element={<TopUp />} />
          <Route path="/give_power" element={<GivePower />} />
          <Route path="/team_income" element={<TeamIncome />} />
          <Route path="/add_capping" element={<AddCapping />} />
          <Route path="/payout_controls" element={<PayoutManagement />} />
          <Route path="/id_settlement" element={<IdSettlement />} />
          <Route path="/income/:slug" element={<IncomeReport />} />
          <Route path="/expo_coin" element={<RoyaltyBonus />} />
          <Route path="/leadership_income" element={<LevelIncome />} />
          <Route path="/introduction_reward" element={<CommunityIncome />} />
          <Route path="/salary_income" element={<SalaryIncome />} />
          <Route path="/utility_income" element={<UtilityIncome />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/add_fund" element={<AddFunds />} />
          <Route path="/register_user" element={<RegisterUser />} />
          <Route path="/buy_order" element={<AdminBuyOrder />} />
          <Route path="/place_withdrawal" element={<FakeWithdrwal />} />
          <Route path="/automate_entries" element={<GenerateFakeEntries />} />
          <Route path="/bank" element={<BankDetails />} />
          <Route path="/user_bank_details" element={<UserBankDetails />} />
          <Route path="/select_upi" element={<UPI />} />
          <Route path="/bonanza_setting" element={<BonanzaSetting />} />
          <Route path="/sip_controls" element={<SIPManagement />} />
          <Route path="/active_sip" element={<ActiveSIP />} />
          <Route path="/completed_sip" element={<CompletedSIP />} />
          <Route path="/active_sip_details" element={<ActiveSIPDetails />} />
          <Route path="/kyc_detail" element={<KycReview key="pan" type="pan" />} />
          <Route path="/kyc_controls" element={<KycControls />} />
          <Route path="/aadhar_kyc_detail" element={<KycReview key="aadhar" type="aadhar" />} />
          <Route path="/aadhar_kyc_controls" element={<AadharKycControls />} />
          <Route path="/installment_controls" element={<InstallmentManagement />} />
          <Route path="/upcoming_installment" element={<UpcomingInstallment />} />
          <Route path="/unpaid_installment" element={<UnpaidInstallment />} />
          <Route path="/bond_paper" element={<BondPaper />} />
          <Route path="/news" element={<News />} />
          <Route path="/general-settings" element={<GeneralSettings />} />
          <Route path="/withdraw-details" element={<WithdrawnDetails />} />
          <Route path="/retrieve_fund" element={<RetrieveFunds />} />
          <Route path="/retrieve_fund_history" element={<RetrieveFundHistory />} />
          <Route path="/contract_withdrawal" element={<ContractWithdrawal />} />
          <Route path="/user_register" element={<UserRegister />} />
          <Route path="/support" element={<Support />} />
          <Route path="/chat" element={<ChatTickets />} />
          <Route path="/released_income" element={<ReleasedIncome />} />
          <Route path="/pending_income" element={<PendingIncome />} />
          <Route path="/release_income_controls" element={<ControlsReleaseIncome />} />
              <Route path="/yield_rewards" element={<BonusIncome />} />
          <Route path="/direct_income" element={<Navigate to="/dashboard/income/direct_income" replace />} />
          <Route path="/rental_income" element={<RentalIncome />} />
          <Route path="/self_rental_income" element={<SelfRentalIncome />} />
          <Route path="/achievement_bonus" element={<AchievementBonus />} />
          <Route path="/exclusive_income" element={<Exclusive />} />
          <Route path="/company_turnover_income" element={<CompanyTurnover />} />
          <Route path="/reward_income" element={<Navigate to="/dashboard/income/reward_income" replace />} />
          <Route path="/team_development_bonus" element={<WorkingIncome />} />
          <Route path="/global_airdrop_reward" element={<FastTeamGrowIncome />} />
          <Route path="/email_req_status" element={<EmailReqStatus />} />
          <Route path="/coin_settings" element={<CoinSettings />} />
          <Route path="/plan_settings" element={<PlanSettings />} />
          <Route path="/activation_requests" element={<ActivationRequests />} />
          <Route path="/deposit_accounts" element={<DepositAccounts />} />
          <Route path="/sub_admins" element={<SubAdmins />} />
          <Route path="/audit_log" element={<AuditLog />} />
          <Route path="/payout_ledger" element={<PayoutLedger />} />
          <Route path="/confirm_package_manually" element={<ConfirmPackageManually />} />
          <Route path="/all_working_income" element={<AllWorkingIncome />} />
          <Route path="/all_fast_team_grow" element={<AllFastTeamGrow />} />
          <Route path="/wealth_lock_history" element={<WealthLockHistory />} />
          <Route path="/vlv_token" element={<VLVToken />} />

          <Route path="/roi_level_income" element={<ROILevelIncome />} />
          <Route path="/matching_bonus" element={<MatchingBonus />} />
          <Route path="/vv_token" element={<VvToken />} />
          <Route path="/roi_income" element={<Navigate to="/dashboard/income/roi_income" replace />} />
          <Route path="/level_income" element={<RoyaltyIncome />} />
          <Route path="/wealth_lock" element={<EmporiumRegularIncome />} />
          <Route path="/leadership_allowance" element={<EmporiumIncome />} />
          <Route path="/enable_2fa" element={<TwoFactorAuthSetup />} />
          <Route path="/token_distribution" element={<TokenDistribution />} />
          <Route path="/update_slot" element={<UpdateSlot />} />
          <Route path="/dummy_user_stats" element={<DummyUserWallet />} />
          <Route path="/dummy_team_update" element={<DummyTeamUpdate />} />
        </Routes>
      </section>
    </React.Fragment>
  );
};

export default NavPages;
